import Axios from 'axios'
import _each from 'lodash/each'
import _filter from 'lodash/filter'
import _merge from 'lodash/merge'
import moment from 'moment'

import StoreCollection from '../StoreCollection.js'

let InvoicesCollection = {}

_merge(InvoicesCollection, StoreCollection, {
  state: {
    apiBaseUrl: '/api/invoice/v1',
    forceOutstanding: false
  },
  getters: {
    Invoices: state => {
      return state.collection || []
    },
    InvoicesUnpaid: (state, getters) => {
      return _filter(getters.Invoices, { total_has_been_paid: false }) || []
    },
    InvoicesWithAttachments: (state, getters) => {
      let invoices = []

      _each(getters.Invoices, invoice => {
        if (invoice.invoice_file) {
          invoices.push(invoice)
        }
      })

      return invoices
    },
    Payments: state => {
      let payments = []

      _each(state.collection || [], i => {
        if (i.payments && i.payments.length) {
          payments = payments.concat(i.payments.slice(0))
        }
      })

      return payments
    },
    CompletedPayments: state => {
      let payments = []

      _each(state.collection || [], invoice => {
        if (invoice.payments && invoice.payments.length) {
          _each(invoice.payments, payment => {
            if (payment.transaction_status === 3 /* COMPLETE */) {
              payments.push(payment)
            }
          })
        }
      })

      return payments
    },
    forceOutstanding: state => {
      return state.forceOutstanding
    }
  },
  actions: {
    getHashedInvoice: (ctx, payload) => {
      if (payload.id && payload.hash) {
        let axios = Axios.create({})

        return axios.get(`${ctx.state.apiBaseUrl}/getHashed/${payload.hash}/${payload.id}`)
      }
    },
    createTerm: (ctx, payload) => {
      return new Promise((resolve, reject) => {
        let axios = Axios.create({})

        axios
          .post(`${ctx.state.apiBaseUrl}/createTerm/${payload.ownerId}`, payload.data)
          .then(res => {
            if ([200, 201].includes(res.status)) {
              ctx.commit('setOne', res.data)
              resolve(res.data)
            } else {
              reject()
            }
          })
      })
    },
    updateInvoice: (ctx, payload) => {
      ctx.commit('setOne', payload)
    },
    setForceOutstanding: (ctx, payload) => {
      ctx.state.forceOutstanding = payload
    }
  }
})

/*
|--------------------------------------------------------------------------
| MODEL METHODS
|--------------------------------------------------------------------------
*/

const PaymentTypes = {
  DEPOSIT: 1,
  TOTAL: 2,
  DUE_NOW: 3
}

class InvoiceStaticMethods {
  /*
    |--------------------------------------------------------------------------
    | STATIC METHODS @todo refactor this into the Vue model
    |--------------------------------------------------------------------------
    */

  static isDueInTotalNow(invoice) {
    if (invoice && invoice.final_payment_due_date) {
      return moment(invoice.final_payment_due_date).isSameOrBefore(moment())
    }
  }

  static depositHasBeenPaid(invoice) {
    return !!(invoice && invoice.deposit_paid_at)
  }

  static currentlyRequiredPaymentType(invoice) {
    if (
      invoice &&
      !InvoiceStaticMethods.depositHasBeenPaid(invoice) &&
      !InvoiceStaticMethods.isDueInTotalNow(invoice) &&
      invoice.final_payment_due_date &&
      moment(invoice.final_payment_due_date).diff(moment.now(), 'days') > 0 &&
      (invoice.deposit_amount || invoice.deposit_cc_fees)
    ) {
      return PaymentTypes.DEPOSIT
    } else {
      if (invoice.amount_due_now > 0) {
        return PaymentTypes.DUE_NOW
      }
      return PaymentTypes.TOTAL
    }
  }

  static amountToBePaidNow(invoice, isCC = false, forceOutstanding = false, returnFeesOnly = false) {
    if (invoice) {
      if (forceOutstanding) {
        if (returnFeesOnly) {
          return isCC ? invoice.invoice_history_result.amountDueFees : 0
        }
        return  invoice.invoice_history_result.cashPriceDue
      }

      if (InvoiceStaticMethods.currentlyRequiredPaymentType(invoice) === PaymentTypes.DUE_NOW) {
        if (returnFeesOnly) {
          return isCC ? invoice.amount_due_now_fees : 0
        }
        return invoice.amount_due_now
      }

      if (InvoiceStaticMethods.currentlyRequiredPaymentType(invoice) === PaymentTypes.DEPOSIT) {
        if (returnFeesOnly) {
          return isCC ? invoice.invoice_history_result.depositDueNowFees : 0
        }
        return  invoice.invoice_history_result.depositDueNow


      } else {
        if (returnFeesOnly) {
          return isCC ? invoice.invoice_history_result.amountDueFees : 0
        }
        return  invoice.invoice_history_result.cashPriceDue
      }
    }
    return 0
  }
}

/*
|--------------------------------------------------------------------------
| EXPORTS
|--------------------------------------------------------------------------
*/

export default InvoicesCollection
export { InvoicesCollection, InvoiceStaticMethods, PaymentTypes }
